export default __webpack_public_path__ + "static/media/icon2.e49a2535.png";